<template>
	<v-dialog v-model="dialog" persistent max-width="70%" scrollable content-class="rounded-xl">
		<v-card>
			<v-card-title class="justify-space-between pb-0">
				<div class="font-size-14 cl-secondary"><v-icon dense color="#e17055" class="pr-3 font-weight-bold">mdi-account-convert</v-icon> Alih Pengguna</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<template v-if="listAccount.length > 0">
				<v-card-text>
					<v-col class="px-0 cl-secondary font-size-11 font-weight-500 border-grey">
						<v-row class="my-2">
							<!-- <template v-for="(data, idx) in listAccount">
								<v-col cols="2" :xs="12" :sm="2" :key="idx" :class="{'selected': selectedAccount && selectedAccount.member_network_code === data.member_network_code}">
									<v-menu open-on-hover offset-x nudge-left="355" nudge-bottom="90" transition="scale-transition" content-class="elevation-0">
										<template v-slot:activator="{ on, attrs }">
											<v-card outlined class="user-card pa-2 elevation-0 rounded-xl hover-shadow h-100" v-bind="attrs" v-on="on" @click="selectAccount(data.member_network_code)">
												<div class="btn-detail">
													<template v-if="selectedAccount && selectedAccount.member_network_code === data.member_network_code">
														<v-btn depressed x-small fab color="primary">
															<v-icon dense color="white">mdi-check-circle</v-icon>
														</v-btn>
													</template>
													<template v-else>
														<v-btn depressed x-small fab color="grey darken-1">
															<v-icon dense color="grey lighten-3">mdi-checkbox-blank-circle</v-icon>
														</v-btn>
													</template>
												</div>
												<div class="rounded-xl overflow-hidden">
													<v-img contain width="75%" class="d-block rounded-xl mx-auto mb-3" style="border-radius: 100%!important;" :src=" (data.member_image) ? data.member_image : '/assets/image/profile-pict.png'"></v-img>
												</div>
												<div class="px-1 py-1 mb-1">
													<div class="font-size-12 product-name cl-dark text-center font-weight-bold"  :class="{'cl-secondary': selectedAccount && selectedAccount.member_network_code === data.member_network_code}">{{ data.member_network_code }}</div>
												</div>
											</v-card>
										</template>

										<v-list class="menu-node">
											<v-list-item>
												<v-card class="elevation-0" width="250">
													<div class="font-size-12 text-uppercase cl-primary font-weight-600">{{ data.member_name }}</div>
													<div class="pt-1 d-flex justify-space-between">
														<div class="d-block w-100 font-size-8 cl-grey">
															<div class="mb-1 d-flex align-center justify-space-between w-100">
																<span>Kode Mitra</span>
																<div class="" :class="(data.member_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
																	<span class="font-weight-500">{{ data.member_network_code }}</span>
																</div>
															</div>

															<div class="mb-1 d-flex align-center justify-space-between w-100">
																<span>Kode Sponsor</span>
																<div class="" :class="(data.member_network_sponsor_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
																	<span class="font-weight-500">{{ data.member_network_sponsor_network_code | emptyData }}</span>
																</div>
															</div>

															<div class="mb-1 d-flex align-center justify-space-between w-100">
																<span>Kode Upline</span>
																<div class="" :class="(data.member_network_upline_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
																	<span class="font-weight-500">{{ data.member_network_upline_network_code | emptyData }}</span>
																</div>
															</div>

															<div class="mb-4 d-flex align-center justify-space-between w-100">
																<span>Posisi</span>
																<div class="font-weight-500 black--text">{{ (data.member_network_position === 'L') ? 'Kiri' : 'Kanan' }}</div>
															</div>

															<div class="mb-1 d-flex align-center justify-space-between w-100">
																<span>Titik Kiri</span>
																<div class="font-weight-500 black--text">{{ data.member_network_total_node_left_main | toNumber }}</div>
															</div>

															<div class="mb-1 d-flex align-center justify-space-between w-100">
																<span>Titik Kanan</span>
																<div class="font-weight-500 black--text">{{ data.member_network_total_node_right_main | toNumber }}</div>
															</div>

															<div class="mb-1 d-flex align-center justify-space-between w-100">
																<span>Bergabung</span>
																<div class="font-weight-500 black--text">{{ data.member_network_activation_datetime | tanggaljam }}</div>
															</div>

														</div>
													</div>
												</v-card>
											</v-list-item>
										</v-list>
									</v-menu>
								</v-col>
							</template> -->
						
							<v-slide-group
								v-model="model"
								class="py-4"
								center-active
								show-arrows
							>
								<v-slide-item
									v-for="(data, idx) in listAccount"
									:key="idx"
									v-slot="{ active, toggle }"
								>
									<div class="pa-3" :class="{'selected': selectedAccount && selectedAccount.member_network_code === data.member_network_code}">
										<v-menu open-on-hover offset-x nudge-left="355" nudge-bottom="90" transition="scale-transition" content-class="elevation-0">
											<template v-slot:activator="{ on, attrs }">
												<v-card outlined class="user-card pa-4 elevation-0 rounded-xl hover-shadow h-100" v-bind="attrs" v-on="on" @click="selectAccount(data.member_network_code)">
													<div class="btn-detail">
														<template v-if="selectedAccount && selectedAccount.member_network_code === data.member_network_code">
															<v-btn depressed x-small fab color="primary">
																<v-icon dense color="white">mdi-check-circle</v-icon>
															</v-btn>
														</template>
														<template v-else>
															<v-btn depressed x-small fab color="grey darken-1">
																<v-icon dense color="grey lighten-3">mdi-checkbox-blank-circle</v-icon>
															</v-btn>
														</template>
													</div>
													<div class="rounded-xl overflow-hidden">
														<v-img contain width="85px" max-height="85px" class="d-block rounded-xl mx-auto mb-5 mt-3" style="border-radius: 100%!important;" :src=" (data.member_image) ? data.member_image : '/assets/image/profile-pict.png'"></v-img>
													</div>
													<div class="px-1 py-1 mb-1">
														<div class="font-size-10 product-name cl-dark text-center font-weight-bold"  :class="{'cl-secondary': selectedAccount && selectedAccount.member_network_code === data.member_network_code}">{{ data.member_network_code }}</div>
													</div>
												</v-card>
											</template>

											<v-list class="menu-node">
												<v-list-item>
													<v-card class="elevation-0" width="250">
														<div class="font-size-12 text-uppercase cl-primary font-weight-600">{{ data.member_name }}</div>
														<div class="pt-1 d-flex justify-space-between">
															<div class="d-block w-100 font-size-8 cl-grey">
																<div class="mb-1 d-flex align-center justify-space-between w-100">
																	<span>Kode Mitra</span>
																	<div class="" :class="(data.member_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
																		<span class="font-weight-500">{{ data.member_network_code }}</span>
																	</div>
																</div>

																<div class="mb-1 d-flex align-center justify-space-between w-100">
																	<span>Kode Sponsor</span>
																	<div class="" :class="(data.member_network_sponsor_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
																		<span class="font-weight-500">{{ data.member_network_sponsor_network_code | emptyData }}</span>
																	</div>
																</div>

																<div class="mb-1 d-flex align-center justify-space-between w-100">
																	<span>Kode Upline</span>
																	<div class="" :class="(data.member_network_upline_network_code === '') ? 'd-block text-right' : 'd-flex align-center'">
																		<span class="font-weight-500">{{ data.member_network_upline_network_code | emptyData }}</span>
																	</div>
																</div>

																<div class="mb-4 d-flex align-center justify-space-between w-100">
																	<span>Posisi</span>
																	<div class="font-weight-500 black--text">{{ (data.member_network_position === 'L') ? 'Kiri' : 'Kanan' }}</div>
																</div>

																<div class="mb-1 d-flex align-center justify-space-between w-100">
																	<span>Titik Kiri</span>
																	<div class="font-weight-500 black--text">{{ data.member_network_total_node_left_main | toNumber }}</div>
																</div>

																<div class="mb-1 d-flex align-center justify-space-between w-100">
																	<span>Titik Kanan</span>
																	<div class="font-weight-500 black--text">{{ data.member_network_total_node_right_main | toNumber }}</div>
																</div>

																<div class="mb-1 d-flex align-center justify-space-between w-100">
																	<span>Bergabung</span>
																	<div class="font-weight-500 black--text">{{ data.member_network_activation_datetime | tanggaljam }}</div>
																</div>

															</div>
														</div>
													</v-card>
												</v-list-item>
											</v-list>
										</v-menu>
									</div>
								</v-slide-item>
							</v-slide-group>
						</v-row>
					</v-col>
				</v-card-text>
			</template>
			<v-card-actions class="d-block d-md-flex">
				<v-col cols="12" sm="12" md="6" class="d-flex justify-center justify-sm-center justify-md-start">
					akun yang tersedia : <strong class="ml-2">{{ listAccount.length }}</strong>
				</v-col>
				<v-col cols="12" sm="12" md="6" class="d-flex justify-center justify-sm-center justify-md-end">
					<v-btn depressed width="130" color="grey lighten-1" class="rounded-lg text-capitalize mx-1 rounded-pill" :loading="btnLoadingProses" :disabled="btnLoadingProses" @click="modalHide">
						<v-icon small v-if="false">mdi-account-reactivate-outline</v-icon>
						<span>Batal</span>
					</v-btn>
					<v-btn depressed color="primary" class="rounded-pill white--text rounded-lg text-capitalize mx-1" :loading="btnLoadingProses" :disabled="btnLoadingProses || !selectedAccount" @click="runSwitchAccount(selectedAccount)">
						<v-icon small>mdi-account-reactivate-outline</v-icon>
						<span>Login Akun<span class="font-weight-bold" v-if="selectedAccount">{{ ' ' + selectedAccount.member_network_code }}</span></span>
					</v-btn>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			btnLoadingProses: false,
			selectedAccount: null,
			model: null,
		}
	},
	computed:{
		// ...mapState('profile', ['listAccount']),
	},
	props: [ 'listAccount' ],
	methods :{
		// ...mapActions('profile', ['getAccountMitra']),
		...mapActions('auth', ['switchAccount']),

		selectAccount(id) {
			if (this.selectedAccount && this.selectedAccount.member_network_code === id) {
				this.selectedAccount = null
			} else {
				this.selectedAccount = this.listAccount.find(x => x.member_network_code === id)
			}
		},

		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.selectedAccount = null
			this.dialog = false
			this.btnLoadingProses = false
		},
		reset() {
			this.selectedAccount = null
		},
		async runSwitchAccount(data) {
			this.btnLoadingProses = await true
			if (data) {
				this.switchAccount({member_network_code: data.member_network_code})
					.then(() => {
						// console.log('switchAccount', response)
						setTimeout(() => {
							window.location = window.location.origin
						}, 600);
					})
					.catch(() => {
						this.btnLoadingProses = false
					})
			} else {
				this.btnLoadingProses = false
			}
		}
	},

	mounted() {
		// this.getAccountMitra()
	},
};
</script>

<style lang="scss" scoped>
	.selected {
		.user-card {
			border-color: #e17055!important;
		}
	}
</style>